/* Pixkom Wishlist — LocalStorage-based */
(function() {
  var STORAGE_KEY = 'pixkom-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function toggleWishlist(productId) {
    var list = getWishlist();
    var id = String(productId);
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    updateAllButtons();
    updateWishlistCount();
    return idx === -1; // true if added
  }

  function updateAllButtons() {
    document.querySelectorAll('.pixkom-wishlist-btn').forEach(function(btn) {
      var id = btn.getAttribute('data-product-id');
      if (isInWishlist(id)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Von Wunschliste entfernen');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Zur Wunschliste hinzufuegen');
      }
    });
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('.pixkom-wishlist-count').forEach(function(el) {
      if (count > 0) {
        el.textContent = count;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    updateAllButtons();
    updateWishlistCount();

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.pixkom-wishlist-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        var productId = btn.getAttribute('data-product-id');
        toggleWishlist(productId);
      }
    });
  });

  // Expose for wishlist page
  window.PixkomWishlist = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist,
    toggleWishlist: toggleWishlist,
    removeFromWishlist: function(productId) {
      var list = getWishlist();
      var id = String(productId);
      var idx = list.indexOf(id);
      if (idx !== -1) {
        list.splice(idx, 1);
        saveWishlist(list);
        updateAllButtons();
        updateWishlistCount();
      }
    }
  };
})();
